import React, { useState } from 'react';
import Sidebar from '../../components/sidebar/sidebar';
import Header from '../../components/header';
import Card from '../../components/Card';

import { useNavigate } from 'react-router-dom';
import ThirdPartyForm from './ThirdPartyForm';
import Styles from './grouppolicyStyle.module.scss';
import ProgressBar from '../../components/ProgressBar/progressbar';

const ThirdPartyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="flex">
      <Sidebar></Sidebar>
      <div className="bg-[var(--Background-Color,#161617)] flex-1">
        <Header title="Group Policy Automation" dropdown={2} />

        <Card className="flex-1">
          <div className={`${Styles.progressBar} items-center justify-between mb-0`}>
            <ProgressBar stepNum={2} identity={'Automation'} />
          </div>
          <ThirdPartyForm />
        </Card>
      </div>
    </div>
  );
};

export default ThirdPartyPolicy;
